/// <reference types="vite/client" />
import axios from 'axios';

export async function loadSurveyFromApi() {
    const apiUrl = window.location.origin;
    try {
        const response = await axios.get(`${apiUrl}/.rest/nodes/v1/questions-ws/?depth=6`);
        
        const questionGroups = extractAndGroupQuestions(response.data);
        return transformQuestionsToSurvey(questionGroups);
    } catch (error) {
        throw error;
    }
}

function extractAndGroupQuestions(data) {
  const groups = [];

  if (data && Array.isArray(data.nodes)) {
    const surveyDataNode = data.nodes.find(
      node => node.name === 'survey-data' && node.type === 'mgnl:folder'
    );
    if (surveyDataNode && Array.isArray(surveyDataNode.nodes)) {
      // Each subfolder is a question
      surveyDataNode.nodes.forEach(questionFolder => {
        if (questionFolder.type === 'mgnl:folder' && Array.isArray(questionFolder.nodes)) {
          // Find the Qx-Question node
          const questionNode = questionFolder.nodes.find(n => n.name.endsWith('-Question'));
          // All other nodes are choices
          const choiceNodes = questionFolder.nodes.filter(n => n !== questionNode);
          if (questionNode) {
            groups.push({
              questionNode,
              choiceNodes
            });
          }
        }
      });
    }
  }

  return groups;
}

function transformQuestionsToSurvey(groups) {
  const survey = {
    title: "Remote Camera Decision Support Tool",
    showProgressBar: "bottom",
    progressBarType: "questions",
    pages: groups.map(group => {
      const name = getFirst(getPropertyValue(group.questionNode, 'name')) || group.questionNode.name;
      const title = getFirst(getPropertyValue(group.questionNode, 'question')) || '';
      const type = getFirst(getPropertyValue(group.questionNode, 'answerType'));
      const questionType = type === 'multiple' ? 'checkbox' : 'radiogroup';
      const visibleIf = getFirst(getPropertyValue(group.questionNode, 'visibleIf')) || '';
      const choices = group.choiceNodes.map(choiceNode => ({
        value: getFirst(getPropertyValue(choiceNode, 'name')) || choiceNode.name,
        text: getFirst(getPropertyValue(choiceNode, 'question')) || '',
        tooltip: getFirst(getPropertyValue(choiceNode, 'tooltip')) || '',
        isExclusive: getFirst(getPropertyValue(choiceNode, 'isExclusive')) === true
      }));
      return {
        name,
        elements: [
          {
            type: questionType,
            name,
            title,
            isRequired: true,
            choices,
            visibleIf: visibleIf,
            exclusiveChoices: choices.filter(choice => choice.isExclusive).map(choice => choice.value)
          }
        ]
      };
    })
  };
  return survey;
}

function getPropertyValue(node, propertyName) {
  const property = node.properties?.find((p) => p.name === propertyName);
  if (!property) return null;
  
  // Handle JCR multi-field values
  if (property.values && Array.isArray(property.values)) {
    try {
      // Try to parse each value as JSON since JCR multi-fields store objects as strings
      return property.values.map(value => {
        try {
          return JSON.parse(value);
        } catch {
          return value;
        }
      });
    } catch {
      return property.values;
    }
  }
  
  return property.values?.[0] || '';
}

function getFirst(val) {
  if (Array.isArray(val)) return val[0];
  return val;
} 